<template>
  <nav class="article-nav">
    <router-link v-if="prevPost" class="" :to="{ name: 'post', params: { id: prevPost.uid }}">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z" fill="#121313"/></svg>
    </router-link>
    <router-link class="c-home-button" :to="{ name: 'homepage' }">
      <svg class="home" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 100 100"><path d="M50,4.9L5.1,47L5,47.1v9.7l11.1-10.6v48.6h67.8V46.3L95,56.9v-9.7L50,4.9z M50,14.3l27.6,26v48.3h-55V40L50,14.3z"></path></svg>
    </router-link>
    <router-link v-if="nextPost" class="" :to="{ name: 'post', params: { id: nextPost.uid }}">
      <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 32 32" width="32"><path d="M32 16c0-0.3-0.1-0.5-0.3-0.7l-9.9-10c-0.4-0.4-1-0.4-1.4 0 -0.4 0.4-0.4 1 0 1.4l8.2 8.3H1c-0.6 0-1 0.5-1 1s0.4 1 1 1h27.6l-8.2 8.3c-0.4 0.4-0.4 1 0 1.4 0.4 0.4 1 0.4 1.4 0l9.9-10C31.9 16.5 32 16.3 32 16z" fill="#121313"/></svg>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'article-nav',
  props: {
    'prevPost': Object,
    'nextPost': Object
  }
}
</script>

<style lang="scss" scoped>
.article-nav {
  bottom: 1rem;
  left: .5rem;
  font-size: 0;
  position: fixed;

  z-index: z('article-nav');

  @media (min-width: $breakpoint-lg) {
    bottom: auto;
    left: auto;
    top: 0;
    right: 0;
  }

  svg {
    max-height: 22px;
    max-width: 22px;

    @media (min-width: 1024px) {
      height: 44px;
      width: 44px;
    }
    &.home {
      height: 22px;
      width: 22px;
      @media (min-width: 1200px) {
        max-height: 24px;
        max-width: 24px;
        height: 44px;
        width: 44px;
      }
    }
  }

  svg path {
    fill: #fff;
  }
}

.article-nav a {
  transition: background-color 200ms ease;
  display: inline-block;
  padding: .25rem;
  color: #fff;
  background-color: rgba(0,0,0,0.3);
  user-select: none;
  font-size: 1rem;
  margin-left: 1px;
  height: 30px;
  line-height: 40px;
  text-align: center;
  width: 30px;

  @media (min-width: $breakpoint-lg) {
    padding: 1rem;
  }

  &:hover {
    background-color: #000;
  }
}

.article-nav.leadership a {
  background-color: $leadership;

  @media (min-width: $breakpoint-lg) {
    background-color: darken($leadership, 5%);
  }

  &:hover {
    background-color: darken($leadership, 9%);
  }
}

.article-nav.legal-market a {
  background-color: $legal-market;

  @media (min-width: $breakpoint-lg) {
    background-color: darken($legal-market, 5%);
  }

  &:hover {
    background-color: darken($legal-market, 9%);
  }
}

.article-nav.legal-tech a {
  background-color: $legal-tech;

  @media (min-width: $breakpoint-lg) {
    background-color: darken($legal-tech, 5%);
  }

  &:hover {
    background-color: darken($legal-tech, 9%);
  }
}

.article-nav.management a {
  background-color: $management;

  @media (min-width: $breakpoint-lg) {
    background-color: darken($management, 5%);
  }

  &:hover {
    background-color: darken($management, 9%);
  }
}
</style>



// WEBPACK FOOTER //
// ArticleNav.vue?4adadbe2